import { type DevTestCommand } from "../devTesting";
import { Packet, PacketType } from "./packet";

export interface DevTestData {
    readonly type: PacketType.DevTest
    readonly command: DevTestCommand
    readonly value: number
}

export const DevTestPacket = new Packet<DevTestData>(PacketType.DevTest, {
    serialize(stream, data) {
        stream.writeUint8(data.command);
        stream.writeUint8(data.value);
    },
    deserialize(stream, data) {
        data.command = stream.readUint8();
        data.value = stream.readUint8();
    }
});
